export enum WalletType {
  Metamask,
  WalletConnect,
}

export function initWalletProps() {
  return {
    scene: '',
    referralCode: '',
    fromType: null,
    isOauth: false,
    group: '',
  };
}
